import * as React from 'react'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService } from '../../../../core/services'
import { InputText } from '../../../atoms'
import AgentLayoutEdit from '../_layouts/edit'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

interface IProps {
  skill: IJsonResponse
}

const FIELDS = {
  id: 'id',
  name: 'name',
  position: 'position',
}

const title = I18n.t('admin.edit', {
  model: I18n.t('skill', { scope: 'activerecord.models' }),
})

const AgentSkillsEdit: React.FC<IProps> = props => {
  const { data, pagination } = agentService.getDataFromJson(props.skill)
  const handleSubmit = React.useCallback(async (initialValues, values) => {
    const { updatedSkills, flush } = await agentService.updateSkills(values)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/agent/agent_skills'
  }, [])

  return (
    <AgentLayoutEdit
      model="skills"
      title={title}
      fields={FIELDS}
      indexLink="/agent/agent_skills"
      formItems={
        <>
          <InputText
            readonly={true}
            name="id"
            defaultValue={data.id}
            label={I18n.t('generic.id')}
          />
          <InputText
            required={true}
            name="name"
            defaultValue={data.name}
            label={I18n.t('generic.name')}
          />
          <InputText
            required={true}
            name="position"
            defaultValue={data.position}
            label={I18n.t('generic.position')}
          />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AgentSkillsEdit
